module.exports = __webpack_public_path__ + "static/media/one.2f7722d6.jpg";